module.exports = __webpack_public_path__ + "static/media/bg-a3-portrait.eaec10ef.png";